// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body:not(.edit-mode) .admin-edit-only {
  display: none !important;
}
.related-links {
  width: 100%;
}
.related-links__filter {
  margin-bottom: 1rem;
}
.related-links__empty {
  padding: 1.5rem 0;
}
.related-links__collapse-controls {
  margin-bottom: 1rem;
  text-align: right;
}
.related-link-editor {
  margin: 1rem 0;
  padding: 1.5rem;
  border: 1px solid #d8dce2;
  border-radius: 0.75rem;
  background: #fff;
  list-style: none;
}
.related-link-editor__title {
  margin: 0 0 1rem 0;
  border-bottom: rgba(0, 0, 0, 0.25);
  padding-bottom: 0.5rem;
}
.related-link-editor__dates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}
@media (max-width: 767px) {
  .related-link-editor__dates {
    grid-template-columns: 1fr;
  }
}
.related-link-editor__types {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.related-link-editor__types .form-check {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
}
.related-link-editor__types .form-check-label {
  margin: 0;
  font-weight: 400;
}
.related-link-editor__form {
  display: grid;
  gap: 1.25rem;
}
.related-link-editor .form-group {
  margin: 0;
}
.related-link-editor label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 600;
}
.related-link-editor .form-control {
  width: 100%;
}
.related-link-editor textarea.form-control {
  min-height: 7rem;
}
.related-link-editor__actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  padding-top: 0.5rem;
}
.related-links-group {
  margin: 0 0 1rem 0;
  padding: 0;
}
.related-links-group__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #d5d5d5;
}
@media (max-width: 575px) {
  .related-links-group__header {
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
  }
}
.related-links-group.is-collapsible {
  cursor: pointer;
}
.related-links-group.is-collapsible:hover {
  background-color: rgba(241, 248, 250, 0.25);
}
.related-links-group__title {
  flex: 1;
}
@media (max-width: 575px) {
  .related-links-group__title {
    order: 0;
  }
}
.related-links-group__title h3 {
  margin: 0;
}
.related-links-group__actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
@media (max-width: 575px) {
  .related-links-group__actions {
    order: 1;
  }
}
.related-links-group__links {
  margin: 0;
  padding: 0;
  list-style: none;
}
.related-links-group__toggle {
  border: 0;
  background: transparent;
  padding: 0.25rem;
}
.related-links-group__link-item {
  margin: 0;
  padding: 0;
  list-style: none;
}
.related-links-group__link-item:last-child .related-link-item {
  border-bottom: none;
}
.related-link-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #d8dce2;
  list-style: none;
}
@media (max-width: 575px) {
  .related-link-item {
    flex-direction: column;
  }
}
.related-link-item__content {
  flex: 1;
  min-width: 0;
}
@media (max-width: 575px) {
  .related-link-item__content {
    width: 100%;
    text-align: left;
    order: 1;
  }
}
.related-link-item__actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex: 0 0 auto;
}
@media (max-width: 575px) {
  .related-link-item__actions {
    width: 100%;
    justify-content: flex-end;
    order: 0;
  }
}
.related-link-item__link-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.related-link-item__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 3rem;
  height: 3rem;
  border-radius: 0.5rem;
  background: #f2f6fb;
  font-size: 1.4rem;
  color: #006aa9;
}
.related-link-item__info {
  min-width: 0;
}
.related-link-item__link {
  display: inline-block;
  font-weight: 600;
}
.related-link-item__extension {
  margin-top: 0.15rem;
  font-size: 0.875rem;
  line-height: 1.2;
  text-transform: uppercase;
  color: #5d6673;
}
.related-link-item__description {
  margin-top: 0.35rem;
  line-height: 1.4;
}
.related-links-admin__settings {
  margin-bottom: 1.5rem;
  background-color: white;
  padding: 1.5rem;
  border-radius: 14px;
}
.related-links-admin__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.related-links-admin__new-group {
  margin-bottom: 1.5rem;
  background-color: white;
  padding: 1.5rem;
  border-radius: 14px;
}
.related-links-admin__item-actions,
.related-links-admin__group-actions {
  display: flex;
  align-items: center;
  gap: 0.15rem;
}
.related-links-admin__icon-button {
  /*display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        margin: 0;
        padding: 0;
        text-decoration: none;*/
}
.related-links-admin__icon-button:disabled {
  opacity: 0.25;
}
.related-links-admin__link-drag-handle,
.related-links-admin__group-drag-handle {
  cursor: grab;
  color: #68737d;
}
.related-links-admin__link-drag-handle:active,
.related-links-admin__group-drag-handle:active {
  cursor: grabbing;
}
.related-links-admin__link-drag-handle {
  cursor: grab;
  touch-action: none;
  user-select: none;
}
.related-links-admin__link-drag-handle:active {
  cursor: grabbing;
}
.related-links-admin__drag-ghost {
  opacity: 0.35;
}
.related-links-admin__drag-chosen {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.12);
}
.related-links-admin__dragging {
  cursor: grabbing;
}
.related-links-admin .related-link-file-upload__drop-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;
  border: 2px dashed #d8dce2;
  border-radius: 0.75rem;
  background: #f9f9f9;
  text-align: center;
}
.related-links-admin .related-link-file-upload__drop-area.drag-over {
  background: #e6f0ff;
  border-color: #0071bc;
}
.related-links-admin .related-link-file-upload__drop-area p {
  margin: 0;
  font-size: 0.875rem;
  color: #5d6673;
}
/*# sourceMappingURL=related-links-v2.css.map */`, "",{"version":3,"sources":["webpack://./related-links-v2.less","webpack://./wwwroot/css/components/related-links-v2.less"],"names":[],"mappings":"AAEA;EAEQ,wBAAA;ACFR;ADMA;EACI,WAAA;ACJJ;ADMI;EACI,mBAAA;ACJR;ADOI;EACI,iBAAA;ACLR;ADQI;EACI,mBAAA;EACA,iBAAA;ACNR;ADUA;EACI,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;ACRJ;ADUI;EACI,kBAAA;EACA,kCAAA;EACA,sBAAA;ACRR;ADWI;EACI,aAAA;EACA,gDAAA;EACA,SAAA;ACTR;ADWQ;EAAA;IACI,0BAAA;ECRV;AACF;ADWI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;ACTR;ADMI;EAMQ,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;ACTZ;ADAI;EAaQ,SAAA;EACA,gBAAA;ACVZ;ADcI;EACI,aAAA;EACA,YAAA;ACZR;ADhCA;EAgDQ,SAAA;ACbR;ADnCA;EAoDQ,cAAA;EACA,qBAAA;EACA,gBAAA;ACdR;ADxCA;EA0DQ,WAAA;ACfR;AD3CA;EA8DQ,gBAAA;AChBR;ADmBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;ACjBR;ADqBA;EACI,kBAAA;EACA,UAAA;ACnBJ;ADqBI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,gCAAA;ACnBR;ADqBQ;EAAA;IACI,sBAAA;IACA,mBAAA;IACA,YAAA;EClBV;AACF;ADqBI;EACI,eAAA;ACnBR;ADqBQ;EACI,2CAAA;ACnBZ;ADuBI;EACI,OAAA;ACrBR;ADuBQ;EAAA;IACI,QAAA;ECpBV;AACF;ADeI;EAQQ,SAAA;ACpBZ;ADwBI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;ACtBR;ADwBQ;EAAA;IACI,QAAA;ECrBV;AACF;ADwBI;EACI,SAAA;EACA,UAAA;EACA,gBAAA;ACtBR;ADyBI;EACI,SAAA;EACA,uBAAA;EACA,gBAAA;ACvBR;AD0BI;EACI,SAAA;EACA,UAAA;EACA,gBAAA;ACxBR;AD0BQ;EAEQ,mBAAA;ACzBhB;AD+BA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;AC7BJ;AD+BI;EAAA;IACI,sBAAA;EC5BN;AACF;AD8BI;EACI,OAAA;EACA,YAAA;AC5BR;AD8BQ;EAAA;IACI,WAAA;IACA,gBAAA;IACA,QAAA;EC3BV;AACF;AD8BI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AC5BR;AD8BQ;EAAA;IACI,WAAA;IACA,yBAAA;IACA,QAAA;EC3BV;AACF;AD8BI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AC5BR;AD+BI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AC7BR;ADgCI;EACI,YAAA;AC9BR;ADiCI;EACI,qBAAA;EACA,gBAAA;AC/BR;ADkCI;EACI,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AChCR;ADmCI;EACI,mBAAA;EACA,gBAAA;ACjCR;ADuCI;EACI,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;ACrCR;ADwCI;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;ACtCR;ADyCI;EACI,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;ACvCR;AD0CI;;EAEI,aAAA;EACA,mBAAA;EACA,YAAA;ACxCR;AD2CI;ECzCF;;;;;;;+BAO6B;AAC/B;AD2CQ;EACI,aAAA;ACzCZ;AD6CI;;EAEI,YAAA;EACA,cAAA;AC3CR;AD6CQ;;EACI,gBAAA;AC1CZ;AD8CI;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;AC5CR;AD8CQ;EACI,gBAAA;AC5CZ;ADgDI;EACI,aAAA;AC9CR;ADiDI;EACI,iDAAA;AC/CR;ADkDI;EACI,gBAAA;AChDR;AD1BA;EA8EQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ACjDR;ADmDQ;EACI,mBAAA;EACA,qBAAA;ACjDZ;AD1CA;EA+FY,SAAA;EACA,mBAAA;EACA,cAAA;AClDZ;AACA,+CAA+C","sourcesContent":["@import \"variables.less\";\n\nbody:not(.edit-mode) {\n    .admin-edit-only {\n        display: none !important;\n    }\n}\n\n.related-links {\n    width: 100%;\n\n    &__filter {\n        margin-bottom: 1rem;\n    }\n\n    &__empty {\n        padding: 1.5rem 0;\n    }\n\n    &__collapse-controls {\n        margin-bottom: 1rem;\n        text-align: right;\n    }\n}\n\n.related-link-editor {\n    margin: 1rem 0;\n    padding: 1.5rem;\n    border: 1px solid #d8dce2;\n    border-radius: .75rem;\n    background: #fff;\n    list-style: none;\n\n    &__title {\n        margin: 0 0 1rem 0;\n        border-bottom: rgba(0,0,0,.25);\n        padding-bottom: .5rem;\n    }\n\n    &__dates {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        gap: 1rem;\n\n        @media (max-width: 767px) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n    &__types {\n        display: flex;\n        align-items: center;\n        gap: 1.5rem;\n\n        .form-check {\n            display: flex;\n            align-items: center;\n            gap: .4rem;\n            margin: 0;\n        }\n\n        .form-check-label {\n            margin: 0;\n            font-weight: 400;\n        }\n    }\n\n    &__form {\n        display: grid;\n        gap: 1.25rem;\n    }\n\n    .form-group {\n        margin: 0;\n    }\n\n    label {\n        display: block;\n        margin-bottom: .4rem;\n        font-weight: 600;\n    }\n\n    .form-control {\n        width: 100%;\n    }\n\n    textarea.form-control {\n        min-height: 7rem;\n    }\n\n    &__actions {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: .75rem;\n        padding-top: .5rem;\n    }\n}\n\n.related-links-group {\n    margin: 0 0 1rem 0;\n    padding: 0;\n\n    &__header {\n        display: flex;\n        align-items: center;\n        gap: .75rem;\n        padding: .75rem 1.25rem;\n        border-bottom: 1px solid #d5d5d5;\n\n        @media(max-width: 575px) {\n            flex-direction: column;\n            align-items: center;\n            gap: 1.25rem;\n        }\n    }\n\n    &.is-collapsible {\n        cursor: pointer;\n\n        &:hover {\n            background-color: fade(@lighter-blue,25%);\n        }\n    }\n\n    &__title {\n        flex: 1;\n\n        @media(max-width: 575px) {\n            order: 0;\n        }\n\n        h3 {\n            margin: 0;\n        }\n    }\n\n    &__actions {\n        display: flex;\n        align-items: center;\n        gap: .25rem;\n\n        @media(max-width: 575px) {\n            order: 1;\n        }\n    }\n\n    &__links {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    &__toggle {\n        border: 0;\n        background: transparent;\n        padding: .25rem;\n    }\n\n    &__link-item {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        &:last-child {\n            .related-link-item {\n                border-bottom: none;\n            }\n        }\n    }\n}\n\n.related-link-item {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1.25rem 1.5rem;\n    border-bottom: 1px solid #d8dce2;\n    list-style: none;\n\n    @media(max-width: 575px) {\n        flex-direction: column;\n    }\n\n    &__content {\n        flex: 1;\n        min-width: 0;\n\n        @media(max-width: 575px) {\n            width: 100%;\n            text-align: left;\n            order: 1;\n        }\n    }\n\n    &__actions {\n        display: flex;\n        align-items: center;\n        gap: .25rem;\n        flex: 0 0 auto;\n\n        @media(max-width: 575px) {\n            width: 100%;\n            justify-content: flex-end;\n            order: 0;\n        }\n    }\n\n    &__link-row {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n    }\n\n    &__icon {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 auto;\n        width: 3rem;\n        height: 3rem;\n        border-radius: .5rem;\n        background: #f2f6fb;\n        font-size: 1.4rem;\n        color: @bold-blue;\n    }\n\n    &__info {\n        min-width: 0;\n    }\n\n    &__link {\n        display: inline-block;\n        font-weight: 600;\n    }\n\n    &__extension {\n        margin-top: .15rem;\n        font-size: .875rem;\n        line-height: 1.2;\n        text-transform: uppercase;\n        color: #5d6673;\n    }\n\n    &__description {\n        margin-top: .35rem;\n        line-height: 1.4;\n    }\n}\n\n.related-links-admin {\n\n    &__settings {\n        margin-bottom: 1.5rem;\n        background-color: white;\n        padding: 1.5rem;\n        border-radius: 14px;\n    }\n\n    &__toolbar {\n        display: flex;\n        flex-wrap: wrap;\n        gap: .5rem;\n        margin-bottom: 1rem;\n    }\n\n    &__new-group {\n        margin-bottom: 1.5rem;\n        background-color: white;\n        padding: 1.5rem;\n        border-radius: 14px;\n    }\n\n    &__item-actions,\n    &__group-actions {\n        display: flex;\n        align-items: center;\n        gap: .15rem;\n    }\n\n    &__icon-button {\n        /*display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 2rem;\n        height: 2rem;\n        margin: 0;\n        padding: 0;\n        text-decoration: none;*/\n\n        &:disabled {\n            opacity: .25;\n        }\n    }\n\n    &__link-drag-handle,\n    &__group-drag-handle {\n        cursor: grab;\n        color: #68737d;\n\n        &:active {\n            cursor: grabbing;\n        }\n    }\n\n    &__link-drag-handle {\n        cursor: grab;\n        touch-action: none;\n        user-select: none;\n\n        &:active {\n            cursor: grabbing;\n        }\n    }\n\n    &__drag-ghost {\n        opacity: .35;\n    }\n\n    &__drag-chosen {\n        box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .12);\n    }\n\n    &__dragging {\n        cursor: grabbing;\n    }\n\n    .related-link-file-upload__drop-area {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 1rem;\n        padding: 1.5rem;\n        border: 2px dashed #d8dce2;\n        border-radius: .75rem;\n        background: #f9f9f9;\n        text-align: center;\n\n        &.drag-over {\n            background: #e6f0ff;\n            border-color: #0071bc;\n        }\n\n        p {\n            margin: 0;\n            font-size: .875rem;\n            color: #5d6673;\n        }\n    }\n}","body:not(.edit-mode) .admin-edit-only {\n  display: none !important;\n}\n.related-links {\n  width: 100%;\n}\n.related-links__filter {\n  margin-bottom: 1rem;\n}\n.related-links__empty {\n  padding: 1.5rem 0;\n}\n.related-links__collapse-controls {\n  margin-bottom: 1rem;\n  text-align: right;\n}\n.related-link-editor {\n  margin: 1rem 0;\n  padding: 1.5rem;\n  border: 1px solid #d8dce2;\n  border-radius: 0.75rem;\n  background: #fff;\n  list-style: none;\n}\n.related-link-editor__title {\n  margin: 0 0 1rem 0;\n  border-bottom: rgba(0, 0, 0, 0.25);\n  padding-bottom: 0.5rem;\n}\n.related-link-editor__dates {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n@media (max-width: 767px) {\n  .related-link-editor__dates {\n    grid-template-columns: 1fr;\n  }\n}\n.related-link-editor__types {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n.related-link-editor__types .form-check {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0;\n}\n.related-link-editor__types .form-check-label {\n  margin: 0;\n  font-weight: 400;\n}\n.related-link-editor__form {\n  display: grid;\n  gap: 1.25rem;\n}\n.related-link-editor .form-group {\n  margin: 0;\n}\n.related-link-editor label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-weight: 600;\n}\n.related-link-editor .form-control {\n  width: 100%;\n}\n.related-link-editor textarea.form-control {\n  min-height: 7rem;\n}\n.related-link-editor__actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  padding-top: 0.5rem;\n}\n.related-links-group {\n  margin: 0 0 1rem 0;\n  padding: 0;\n}\n.related-links-group__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #d5d5d5;\n}\n@media (max-width: 575px) {\n  .related-links-group__header {\n    flex-direction: column;\n    align-items: center;\n    gap: 1.25rem;\n  }\n}\n.related-links-group.is-collapsible {\n  cursor: pointer;\n}\n.related-links-group.is-collapsible:hover {\n  background-color: rgba(241, 248, 250, 0.25);\n}\n.related-links-group__title {\n  flex: 1;\n}\n@media (max-width: 575px) {\n  .related-links-group__title {\n    order: 0;\n  }\n}\n.related-links-group__title h3 {\n  margin: 0;\n}\n.related-links-group__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n@media (max-width: 575px) {\n  .related-links-group__actions {\n    order: 1;\n  }\n}\n.related-links-group__links {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.related-links-group__toggle {\n  border: 0;\n  background: transparent;\n  padding: 0.25rem;\n}\n.related-links-group__link-item {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.related-links-group__link-item:last-child .related-link-item {\n  border-bottom: none;\n}\n.related-link-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #d8dce2;\n  list-style: none;\n}\n@media (max-width: 575px) {\n  .related-link-item {\n    flex-direction: column;\n  }\n}\n.related-link-item__content {\n  flex: 1;\n  min-width: 0;\n}\n@media (max-width: 575px) {\n  .related-link-item__content {\n    width: 100%;\n    text-align: left;\n    order: 1;\n  }\n}\n.related-link-item__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  flex: 0 0 auto;\n}\n@media (max-width: 575px) {\n  .related-link-item__actions {\n    width: 100%;\n    justify-content: flex-end;\n    order: 0;\n  }\n}\n.related-link-item__link-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.related-link-item__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 0.5rem;\n  background: #f2f6fb;\n  font-size: 1.4rem;\n  color: #006aa9;\n}\n.related-link-item__info {\n  min-width: 0;\n}\n.related-link-item__link {\n  display: inline-block;\n  font-weight: 600;\n}\n.related-link-item__extension {\n  margin-top: 0.15rem;\n  font-size: 0.875rem;\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #5d6673;\n}\n.related-link-item__description {\n  margin-top: 0.35rem;\n  line-height: 1.4;\n}\n.related-links-admin__settings {\n  margin-bottom: 1.5rem;\n  background-color: white;\n  padding: 1.5rem;\n  border-radius: 14px;\n}\n.related-links-admin__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n.related-links-admin__new-group {\n  margin-bottom: 1.5rem;\n  background-color: white;\n  padding: 1.5rem;\n  border-radius: 14px;\n}\n.related-links-admin__item-actions,\n.related-links-admin__group-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.15rem;\n}\n.related-links-admin__icon-button {\n  /*display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 2rem;\n        height: 2rem;\n        margin: 0;\n        padding: 0;\n        text-decoration: none;*/\n}\n.related-links-admin__icon-button:disabled {\n  opacity: 0.25;\n}\n.related-links-admin__link-drag-handle,\n.related-links-admin__group-drag-handle {\n  cursor: grab;\n  color: #68737d;\n}\n.related-links-admin__link-drag-handle:active,\n.related-links-admin__group-drag-handle:active {\n  cursor: grabbing;\n}\n.related-links-admin__link-drag-handle {\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n.related-links-admin__link-drag-handle:active {\n  cursor: grabbing;\n}\n.related-links-admin__drag-ghost {\n  opacity: 0.35;\n}\n.related-links-admin__drag-chosen {\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.12);\n}\n.related-links-admin__dragging {\n  cursor: grabbing;\n}\n.related-links-admin .related-link-file-upload__drop-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  border: 2px dashed #d8dce2;\n  border-radius: 0.75rem;\n  background: #f9f9f9;\n  text-align: center;\n}\n.related-links-admin .related-link-file-upload__drop-area.drag-over {\n  background: #e6f0ff;\n  border-color: #0071bc;\n}\n.related-links-admin .related-link-file-upload__drop-area p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #5d6673;\n}\n/*# sourceMappingURL=related-links-v2.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
